import Percent from '../src/Percent/index';
export default Percent;
